import React from 'react'

export default props => (
  <svg height={props.size} width={props.size} viewBox="0 0 24 24">
    <path d="M2,3H11V12H2V3M11,22H2V13H11V22M21,3V12H12V3H21M21,22H12V13H21V22Z" />
  </svg>
)
